import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function PrintingSupplies() {
  return <DetailPage type="product" id="printing-supplies" />;
}
